// Zebra Browser Print — local helper service (free from Zebra) that relays raw EPL/ZPL to any
// Zebra the PC can see (USB or Windows-shared). Choice is stored per PC in localStorage.
import { toast } from 'sonner';
import { buildStickerEPL } from './usbPrinter';

const HOSTS = ['http://127.0.0.1:9100', 'https://127.0.0.1:9101'];
const LS_KEY = 'tdr_browser_print';

export const getBrowserPrintConfig = () => {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch { return {}; }
};

export const setBrowserPrintConfig = (cfg) => localStorage.setItem(LS_KEY, JSON.stringify(cfg));

// text/plain body avoids a CORS preflight, matching Zebra's own SDK.
async function bpFetch(path, body) {
  let lastErr;
  for (const host of HOSTS) {
    try {
      const res = await fetch(`${host}${path}`, body === undefined ? {} : {
        method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error(`Browser Print error ${res.status}: ${await res.text()}`);
      return await res.text();
    } catch (e) { lastErr = e; }
  }
  throw new Error(lastErr?.message?.startsWith('Browser Print')
    ? lastErr.message
    : 'Zebra Browser Print is not running on this PC. Install/start it, then try again.');
}

export async function listBrowserPrintPrinters() {
  const text = await bpFetch('/available');
  const data = text ? JSON.parse(text) : {};
  return data.printer || [];
}

export async function sendViaBrowserPrint(device, data) {
  await bpFetch('/write', { device, data });
}

export async function printStickerViaBrowserPrint(job, settings) {
  const { device } = getBrowserPrintConfig();
  try {
    if (!device) throw new Error('No Zebra selected for this PC — pick one in Settings → Sticker Printing.');
    await sendViaBrowserPrint(device, buildStickerEPL(job, settings));
    toast.success(`Sticker sent to ${device.name}`);
    return true;
  } catch (e) {
    toast.error(e.message, { duration: 6000 });
    return false;
  }
}
